import './App.css';
import  React  from 'react';
import QuizeQue from './components/QuizeQue';
 
function App() {
    return (
     <div className="App">
      <h1>React Quiz </h1>
       <QuizeQue/>
      
    </div>
   );
}

export default App;
